import styled from 'styled-components'
import { height, HeightProps, width, WidthProps } from 'styled-system'

export const Container = styled.div<WidthProps & HeightProps>`
  display: flex;
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 110%;
    height: 110%;
    object-fit: cover;
    object-position: center;
  }

  ${width}
  ${height}
`
